module.exports = __webpack_public_path__ + "static/media/WelcomeWeekCover.22cba4d4.jpg";